<template>
  <validation-observer ref="form">
    <div id="Tab6" class="mx-1">
      <div class="row pt-4">
        <div class="col-12">
          <section-title
            content="Confirmar Cita y Verificar Información de Contacto"
          />
          <div class="dropdown-divider mt-0 ml-3" />
        </div>
      </div>
      <div class="row mt-4 mx-2">
        <div class="col-12 pl-2">
          <strong>Información de Cita es la siguiente:</strong>
        </div>
      </div>
      <div class="row mt-2 mx-2">
        <div class="col-md-4 col-sm-6 mb-3">
          <strong>Disciplina:</strong>
          <div>
            <span id="lblAppointmentDiscipline" class="font-weight-normal">
              {{ info.appointment.discipline }}
            </span>
          </div>
        </div>
        <div class="col-md-4 col-sm-6 mb-3">
          <strong>Día:</strong>
          <div>
            <span id="lblAppointmentDate" class="font-weight-normal">
              {{ info.appointment.date }}
            </span>
          </div>
        </div>
        <div class="col-md-4 col-sm-6 mb-3">
          <strong>Localización:</strong>
          <div>
            <span id="lblAppointmentLocation" class="font-weight-normal">
              {{ info.appointment.location }}
            </span>
          </div>
        </div>
      </div>

      <div class="row mx-2">
        <div class="col-md-4 col-sm-6 mb-3 pr-5">
          <ValidationProvider
            v-if="isCenterVisible"
            v-slot="{ errors }"
            name="centro"
            rules="required"
          >
            <custom-drop-down
              id="ddlSelectedCenter"
              v-model="selectedCenterId"
              fieldname="name"
              fieldkey="id"
              placeholder="Seleccione"
              :options="centers"
              label="Centro:"
              :error="errors[0]"
              :custom-error-msg="resources['0166']"
            />
          </ValidationProvider>
          <ValidationProvider
            v-slot="{ errors }"
            name="Tipo de Visita"
            rules="required"
          >
            <custom-drop-down
              id="ddlSelectedCenter"
              v-model="typeIdSelected"
              fieldname="name"
              fieldkey="id"
              placeholder="Seleccione"
              :options="appointmentType"
              label="Tipo de Visita:"
              :error="errors[0]"
              :custom-error-msg="'El tipo de Visita es requerido.'"
            />
          </ValidationProvider>
        </div>
        <div class="col-4">
          <strong>Horario:</strong>
          <div>
            <span id="lblAppointmentSchedule" class="font-weight-normal">
              {{ info.appointment.schedule }}
            </span>
          </div>
        </div>
        <div class="col-4">
          <strong>Pueblo:</strong>
          <div>
            <span id="lblAppointmentMunicipality" class="font-weight-normal">
              {{ info.appointment.municipality }}
            </span>
          </div>
        </div>
      </div>

      <div class="row pt-5">
        <div class="col-12">
          <section-title content="Favor verificar su información de contacto" />
          <div class="dropdown-divider mt-0 ml-3" />
        </div>
      </div>

      <form name="generalForm" novalidate @submit.prevent="save">
        <div class="row mx-2 mt-2">
          <div class="col-md-4 col-sm-6 mb-2 pr-5">
            <ValidationProvider
              v-slot="{ errors }"
              name="nombre"
              rules="required"
            >
              <CustomInput
                id="txtContactName"
                v-model="info.StudentContactInformation.contactName"
                label="Nombre: "
                required
                :error="errors[0]"
                :custom-error-msg="resources['0170']"
              />
            </ValidationProvider>
          </div>
          <div class="col-md-4 col-sm-6 mb-2 pr-5">
            <ValidationProvider
              v-slot="{ errors }"
              name="parentesco"
              rules="required"
            >
              <custom-drop-down
                id="ddlSelectedRelationship"
                v-model="selectedRelationship"
                fieldname="spaShortDescription"
                fieldkey="eduespCodeId"
                :options="relationships"
                placeholder="Seleccione"
                label="Parentesco:"
                :error="errors[0]"
                :custom-error-msg="resources['0406']"
              />
            </ValidationProvider>
          </div>
          <div class="col-md-4 col-sm-6 w-90 mb-2">
            <ValidationProvider
              v-slot="{ errors }"
              name="email"
              :rules="emailValidation"
              :custom-messages="{
                required: 'El campo Correo Electrónico es requerido. (0518)',
                email: 'Favor de entrar un correo electrónico válido.'
              }"
            >
              <CustomInput
                id="txtContactEmail"
                v-model="info.StudentContactInformation.contactEmail"
                label="Correo Electrónico: "
                :error="errors[0]"
                :custom-error-msg="errors[0]"
              />
            </ValidationProvider>
          </div>
        </div>
        <div class="row mx-2 mt-2">
          <div class="col-md-4 col-sm-6 pr-5">
            <ValidationProvider
              v-slot="{ errors }"
              name="teléfono"
              rules="required|completePhone"
              :custom-messages="{
                completePhone: 'El número de teléfono no es valido.',
                required: resources['0173']
              }"
            >
              <CustomInput
                id="txtContactTelephone"
                v-model="info.StudentContactInformation.contactTelephone"
                label="Teléfono: "
                mask-type="Phone"
                placeholder="(__) __-____"
                :error="errors[0]"
                :custom-error-msg="errors[0]"
              />
            </ValidationProvider>
          </div>
          <div class="col-md-4 col-sm-6 pr-5">
            <ValidationProvider
              v-if="info.StudentContactInformation.receiveMessageTextFlag"
              v-slot="{ errors }"
              name="proveedor"
              rules="required"
            >
              <custom-drop-down
                id="ddlContactProvider"
                v-model="selectedContactProvider"
                fieldname="telephoneProviderName"
                fieldkey="telephoneProviderNo"
                placeholder="Seleccione"
                :options="providers"
                label="Proveedor:"
                :error="errors[0]"
                :custom-error-msg="resources['0172']"
              />
            </ValidationProvider>
          </div>
          <div class="col-4 pr-5 pt-0">
            <div class="custom-control custom-checkbox checkbox-top-spacing">
              <input
                id="chkNoEmail"
                v-model="info.noEmail"
                type="checkbox"
                name="chkNoEmail"
                :mask-type="'email'"
                class="custom-control-input"
                @change="onChangeNoEmailProvided($event)"
              />
              <label for="chkNoEmail" class="custom-control-label font regular">
                <span><em class="ic-check"/></span>
                No desea administrar un correo electrónico
              </label>
            </div>
          </div>
        </div>
        <div class="row mx-2">
          <div class="col-4 pr-5">
            <div class="custom-control custom-checkbox checkbox-top-spacing">
              <input
                id="chkReceiveTextMessage"
                v-model="info.StudentContactInformation.receiveMessageTextFlag"
                type="checkbox"
                name="chkReceiveTextMessage"
                class="custom-control-input"
              />
              <label
                for="chkReceiveTextMessage"
                class="custom-control-label font regular"
              >
                <span><em class="ic-check"/></span>
                Desea recibir mensaje de texto
              </label>
            </div>
          </div>
          <div class="col-4" />
          <div class="col-4" />
        </div>

        <div class="row mx-1 pt-4">
          <div class="col-12">
            <title-breadcrumb
              :page="{ title: 'Confirmación', icon: 'far fa-check-circle' }"
              :has-route="false"
            />
          </div>
        </div>

        <div class="row mx-1 pt-3">
          <div class="col-12">
            <ValidationProvider
              v-slot="{ errors }"
              name="accept"
              rules="required"
            >
              <custom-checkbox-single-option
                id="chkConfirmAppointment"
                v-model="info.accept"
                title="¿Está seguro que desea confirmar esta cita?"
                option-text="Confirmar Cita"
                :error="errors[0]"
                custom-error-msg="Favor confirmar la cita para continuar."
              />
            </ValidationProvider>
          </div>
        </div>
      </form>
    </div>
  </validation-observer>
</template>

<script>
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { SectionTitle } from "@/components/pei/shared";
import TitleBreadcrumb from "@/components/common/page/TitleBreadcrumb";
import { CustomDropDown, CustomInput } from "@/components/common";
import CustomCheckboxSingleOption from "@/components/common/CustomCheckboxSingleOption";
import resourcesService from "@/services/resources.js";
import alert from "@/mixin/alert.mixin";
import appointmentServices from "@/services/api/appointment.api.js";

export default {
  name: "Tab6",
  mixins: [alert],
  components: {
    ValidationObserver,
    ValidationProvider,
    SectionTitle,
    TitleBreadcrumb,
    CustomInput,
    CustomDropDown,
    CustomCheckboxSingleOption
  },
  props: {
    clientAppointmentId: {
      type: Number,
      required: true,
      default: 0
    },
    student: {
      type: Object,
      required: true
    },
    referralReason: {
      type: String,
      required: false,
      default: () => null
    },
    cancelAppointmentAction: {
      type: Object,
      default: () => null
    }
  },
  data: () => ({
    resources: [],
    providers: [],
    relationships: [],
    centers: [],
    appointmentType: [],
    //
    info: {
      studentSieId: null,
      evaluationTypeId: null,
      coordinatedByCenterId: null,
      typeId: null,
      regStudentPostRegistryId: null,
      isInitialRegister: null,
      accept: null,
      appointment: {
        timeStart: null,
        timeEnd: null,
        clientAppointmentId: null,
        subject: null,
        discipline: null,
        date: null,
        location: null,
        schedule: null,
        municipality: null
      },
      StudentContactInformation: {
        contactName: null,
        contactEmail: null,
        emailSuppliedFlag: false,
        contactTelephone: null,
        contactTelephoneProviderCode: 0,
        regStudentId: null,
        contactRelation: null,
        principalEmail: null,
        receiveMessageTextFlag: false
      }
    },
    selectedRelationship: null,
    selectedContactProvider: null,
    selectedCenterId: null,
    typeIdSelected: null
  }),
  methods: {
    async GetAppointmentInfo() {
      await this.$ApiGet(
        "api/appointment/info?clientAppointmentId=" + this.clientAppointmentId
      )
        .then(res => {
          this.info.appointment = res.data;
        })
        .catch(err => {
          this.response = err;
        });
    },
    async GetRelationships() {
      await this.$ApiGet("api/student/eduespcodes")
        .then(res => {
          this.relationships = res.data;
        })
        .catch(err => {
          this.response = err;
        });
    },
    async GetPhoneProviders() {
      await this.$ApiGet("api/student/TelephoneProviders")
        .then(res => {
          this.providers = res.data;
        })
        .catch(err => {
          this.response = err;
        });
    },
    async GetContactInfo() {
      await this.$ApiGet(
        `api/student/${this.student.studentId}/ContactInformation`
      )
        .then(res => {
          if (res.data) {
            this.info.schoolEmail = res.data.principalEmail;
            this.info.StudentContactInformation.regStudentId =
              res.data.regStudentId;
            this.info.StudentContactInformation.contactName =
              res.data.contactName;
            this.info.StudentContactInformation.contactRelation =
              res.data.contactRelation;
            this.info.StudentContactInformation.contactTelephone =
              res.data.contactTelephone;
            this.info.StudentContactInformation.contactTelephoneProviderCode =
              res.data.contactTelephoneProviderCode;
            this.info.StudentContactInformation.contactEmail =
              res.data.contactEmail;

            if (res.data.contactRelation) {
              this.selectedRelationship = this.relationships.find(
                x => x.eduespCodeId == res.data.contactRelation
              );
            }
          }
        })
        .catch(err => {
          this.response = err;
        });
    },
    async GetCenters() {
      let self = this;
      // Verifica si el usuario tiene mas de un centro.
      if (
        this.userProfile.centerId != null &&
        this.userProfile.centerId.split(",").length > 1
      ) {
        await this.$ApiGet(
          "api/eduespuserlocation/servicecenterbyuserid?userId=" +
            this.userProfile.sub
        )
          .then(res => {
            self.centers = res.data;
          })
          .catch(err => {
            this.response = err;
          });
      } else {
        await this.$ApiGet("api/code/servicecenter")
          .then(res => {
            self.centers = res.data;
          })
          .catch(err => {
            this.response = err;
          });
      }
    },
    onChangeNoEmailProvided() {
      if (this.info.noEmail) {
        this.info.StudentContactInformation.contactEmail = this.info.schoolEmail;
      } else {
        this.info.StudentContactInformation.contactEmail = null;
      }
    },
    async loadResources() {
      let resourceCodes = ["0170", "0172", "0173", "0406", "0518", "0166"];

      this.resources = await resourcesService.LoadValidationMessages(
        resourceCodes
      );
    },
    async save(args = {}) {
      let isFormValid = await this.$refs.form.validate();

      if (isFormValid && this.info.accept == true) {
        this.info.subject = this.referralReason;
        this.info.clientAppointmentId = this.info.appointment.clientAppointmentId;
        this.info.timeStart = this.info.appointment.timeStart;
        this.info.timeEnd = this.info.appointment.timeEnd;
        this.info.studentSieId = Number(this.student.studentId);
        this.info.isInitialRegister = !this.student.isInitialRegister;
        this.info.typeId = this.typeIdSelected.id;
        this.info.StudentContactInformation.contactTelephoneProviderCode = this
          .selectedContactProvider
          ? this.selectedContactProvider.telephoneProviderNo
          : 0;
        this.info.StudentContactInformation.contactRelation = this.selectedRelationship.eduespCodeId;
        this.info.coordinatedByCenterId =
          this.selectedCenterId != null
            ? this.selectedCenterId.id
            : this.userCenterId;
        this.info.regStudentPostRegistryId = this.isPostRegistry ? Number(this.studentPreRegistry.regStudentPostRegistryId) : null;
        if (!this.info.StudentContactInformation.emailSuppliedFlag) {
          this.info.StudentContactInformation.principalEmail = this.info.StudentContactInformation.contactEmail;
        }

        let sendData = {
          appointmentToCoordinate: {
            ...this.info,
            ...args,
            evaluationTypeId: parseInt(this.$route.query.evaluationTypeId)
          },
          appointmentToCancel: this.cancelAppointmentAction
        };

        await this.$ApiPost("/api/appointment/coordinate", sendData)
          .then(async res => {
            if (res && res.data) {
              this.ShowToast(
                "Notificación",
                "Los datos fueron guardados exitosamente.",
                "success"
              );
              const nextSection = 3;
              this.$emit("change-section", nextSection);
              this.$emit("confirm-save");
            }
          })
          .catch(err => {
            if (err && err.response && err.response.data) {
              this.ShowToast("Error", err.response.data.message, "error");
            } else {
              this.ShowToast("Error", err.message, "error");
            }
          });
      }
    },
    async getAppointmentType() {
      await appointmentServices.getAppointmentType().then(data => {
        this.appointmentType = data.data;
      });
    }
  },
  async mounted() {
    await this.GetAppointmentInfo();
    await this.GetRelationships();
    await this.GetPhoneProviders();
    await this.GetCenters();
    await this.loadResources();
    await this.GetContactInfo();
    await this.getAppointmentType();
    this.$store.commit("setSaveMethod", this.save);
  },
  computed: {
    isCenterVisible() {
      if (this.userProfile.centerId == null) {
        return true;
      } else if (
        this.userProfile.centerId != null &&
        this.userProfile.centerId.split(",").length > 1
      ) {
        return true;
      } else {
        return false;
      }
    },
    emailValidation() {
      return !this.info.noEmail ? "required|email" : "email";
    },
    userCenterId() {
      if (this.userProfile.centerId == null) {
        return null;
      } else if (
        this.userProfile.centerId != null &&
        this.userProfile.centerId.split(",").length > 1
      ) {
        return null;
      } else {
        return parseInt(this.userProfile.centerId);
      }
    },
    propertiesWatched() {
      const { info, selectedCenterId, selectedRelationship } = this;
      return {
        info,
        selectedCenterId,
        selectedRelationship
      };
    },
    studentPreRegistry() {
      return this.$store.getters["$_student/getStudentPreRegistry"];
    },
    isPostRegistry() {
      return this.studentPreRegistry?.isPostRegistry;
    },
  },
  watch: {
    propertiesWatched: {
      handler: function() {
        let data = {
          ...this.info,
          selectedCenter: this.selectedCenterId,
          selectedRelationship: this.selectedRelationship,
          selectedContactProvider: this.selectedContactProvider
        };

        this.$emit("contact-info", data);
      },
      deep: true
    }
  }
};
</script>
